var map = {
	"./acer.webp": 9675,
	"./apple.webp": 1932,
	"./asus.webp": 4296,
	"./dell.webp": 9271,
	"./epson.webp": 543,
	"./hp.webp": 5444,
	"./lenovo.webp": 5971,
	"./microsoft.webp": 320,
	"./msi.webp": 147,
	"./toshiba.webp": 6276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3848;